const GeneralConst = {
	apiBaseUrl: process.env.REACT_APP_SERVER_API_URL,
	// apiBaseUrl: process.env.NODE_ENV === "development" ? "http://awdev.askwinston.ca" : ""
	// apiBaseUrl: "http://awdev.askwinston.ca"
	// apiBaseUrl: "http://localhost:8080"
};

export default GeneralConst;
